export default __webpack_public_path__ + "static/media/arequipa-street_&_mountains.634c90fa.jpg";